module.exports = __webpack_public_path__ + "static/media/tot-background-layer-2~bmhcQBNH.7474be8b.png";